<script setup>
import { LoaderCircle } from "@lucide/vue";
defineProps({
  variant: { type: String, default: "primary" },
  loading: Boolean,
  disabled: Boolean,
  type: { type: String, default: "button" },
});
</script>
<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="variant === 'danger' ? 'btn-danger' : variant === 'secondary' ? 'btn-secondary' : 'btn-primary'"
  >
    <LoaderCircle v-if="loading" class="size-4 animate-spin" />
    <slot />
  </button>
</template>

